module.exports = __webpack_public_path__ + "img/c8b876fc62f08c9a9629b284772b42e8.png";